import { createFileRoute } from '@tanstack/react-router'

import { ByOriginScreen } from './-components/by-origin-screen.tsx'

export const Route = createFileRoute('/risk/chargebacks-by-origin')({
  component: ByOriginScreen
})
